import { useCallback, useEffect, useState } from 'react';
import useS3Upload from '#hooks/use-upload.js';
import { checkImageFormat } from '#helpers/helpers.js';
import toast from 'react-hot-toast';

export function useMedia({ initialData, onAdd, onUpload, onDelete, setUnsavedChanges }) {
    const [media, setMedia] = useState(null);
    const setHasUnsavedChanges = typeof setUnsavedChanges === 'function' ? setUnsavedChanges : () => { };

    useEffect(() => {
        setMedia({ meta: typeof initialData === 'object' ? initialData : null });
    }, [initialData]);

    const s3Upload = useS3Upload({
        onSuccess: ({ file, tempKey }) => {
            const meta = {
                src: `${MEDIA_URL}/${tempKey}`,
                name: file.name,
                coords: file.coords
            }
            setMedia({ meta });
            if (typeof onUpload === 'function')
                onUpload(meta);
        },
        onBeforeUpload: (e) => {
            const [file] = e.target.files;
            return checkImageFormat(file);
        }
    });

    const addAction = useCallback(
        (e, initCoords) => {
            if (!e) return;
            let file
            if (e?.nativeEvent instanceof Event) file = e.target.files[0];
            else file = e;
            console.log('file: ', file)
            let allowSetMedia = true, isUploading = undefined;
            if (file instanceof File) {
                // caso immagini caricate dal dispositivo
                file.coords = initCoords || { x: 0, y: 0 };
                allowSetMedia = s3Upload.props.onChange({ target: { files: [file] } });
                isUploading = true;

                if (!allowSetMedia) {
                    isUploading = undefined;
                    toast.error('Error uploading file, please try again.');
                    setMedia(null);
                    return null;
                }
            }

            const fileSrc = file instanceof File ? URL.createObjectURL(file) : file.src;
            const newMedia = {
                fileUrl: fileSrc,
                meta: {
                    src: fileSrc,
                    coords: initCoords,
                    name: file.name,
                    isUploading
                }
            };

            console.log('newMedia: ', newMedia)

            setMedia(newMedia);
            setHasUnsavedChanges(true);
            if (typeof onAdd === 'function') onAdd(newMedia.meta);
            return true;
        },
        [setMedia, onAdd, s3Upload]
    );

    const editAction = useCallback(
        (coords) => {
            setMedia(media => {
                const newMedia = structuredClone(media);
                newMedia.coords = coords;
                return newMedia
            });
        },
        []
    );

    const clearAction = useCallback(() => {
        s3Upload.props.onClear();
        setMedia({ meta: null });
        setHasUnsavedChanges(true);
        if (typeof onDelete === 'function') onDelete();
    }, [s3Upload]);

    return {
        data: media,
        handlers: { onChange: addAction, onEdit: editAction, onClear: clearAction }
    };
}
